"use client";
import { jsx as s } from "react/jsx-runtime";
import { css as a } from "@emotion/react";
import n from "@emotion/styled";
import { COLORS as g } from "../../tokens/colors/Colors.js";
import { HEADING_SIZES as e } from "../../tokens/heading-sizes/HeadingSizes.js";
import { HEADING_WEIGHTS as t } from "../../tokens/heading-weights/HeadingWeights.js";
import { forwardRef as d } from "react";
const r = d(
  ({ children: i, ...o }, m) => /* @__PURE__ */ s(f, { ...o, "data-comp": "heading", ref: m, children: i })
);
r.displayName = "Heading";
const I = r, h = {
  h1: { size: e.h1, weight: t.h1 },
  h2: { size: e.h2, weight: t.h2 },
  h3: { size: e.h3, weight: t.h3 },
  h4: { size: e.h4, weight: t.h4 }
}, f = n.h1(
  ({ as: i, feStyledAs: o }) => a`
		color: ${g.black};
		font-size: ${h[o ?? i].size};
		font-weight: ${h[o ?? i].weight};
	`
);
export {
  I as default
};
